import React, { useContext } from 'react';
import AppContext from '../context/Context';
import AccountingRoutes from '../routes/AccountingRoutes';

const AccountingLayout = ( ) => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <AccountingRoutes />
            </div>
}

export default AccountingLayout;